<sl-label size="large" i18n>Connect to Economic</sl-label>
<sl-label color="dark" i18n>This will connect your accounting system with Previsto</sl-label>
<sl-input [(ngModel)]="systemKey" label="Api key" i18n-label></sl-input>

<div class="mt-8 text-right">
    <sl-button (click)="close()" i18n>Cancel</sl-button>
    <sl-button (click)="connect()" class="ml-3" type="primary" i18n>Connect</sl-button>
</div>